import { RoleName } from './user-role-types';

export interface ActiveMember {
  user_id: string;
  name: string;
  picture: string;
  email: string;
  roles: Role[];
  relatedIDs: string[];
  kind: MemberKind.ActiveMember | MemberKind.PendingInvitationMember;
}

export interface Role {
  id: string;
  name: RoleName;
  description: string;
}

export interface MembersScreenResponse {
  activeMembers: ActiveMember[];
  availableRoles: Role[];
  pendingInvitationMembers: PendingInvitationMember[];
}

export interface InvitationInput {
  inviteeEmail: string;
  inviteeRoles: string[];
  connectionId?: string;
}

export interface PendingInvitationMember {
  id: string;
  inviteeEmail: string;
  created_at: string;
  expires_at: string;
  kind: MemberKind.ActiveMember | MemberKind.PendingInvitationMember;
}

export interface UserRolesInput {
  userId: string;
  roleIDs: string[];
}

export enum TableMemberStatus {
  Active = 'Active',
  Pending = 'Pending',
  Expired = 'Expired',
}

export const isActiveMember = (
  member: ActiveMember | PendingInvitationMember,
): member is ActiveMember => {
  return member.kind === MemberKind.ActiveMember;
};

export enum MemberKind {
  ActiveMember = 'ActiveMember',
  PendingInvitationMember = 'PendingInvitationMember',
}

export enum VerificationText {
  RemoveActiveMember = 'remove',
  DeleteOrganization = 'delete',
}
